<template>
  <b-card
    class="card-transaction"
    no-body
  >
    <b-card-header class="mb-3">
      <b-card-title>
        {{ $t('Loan Portfolio Risk Summary') }}
      </b-card-title>

      <feather-icon
        icon="RotateCwIcon"
        class="cursor-pointer"
        @click="fetchPortfolioRiskSummary"
      />
    </b-card-header>

    <b-card-body>
      <div
        v-for="transaction in loanPortfolioSummary"
        :key="transaction.loanStatus"
        class="transaction-item"
      >
        <b-media no-body>
          <b-media-body>
            <h6 class="transaction-title">
              {{ transaction.loanStatus }}
            </h6>
            <small>{{ transaction.percentage }}%</small>
          </b-media-body>
        </b-media>
        <div
          class="font-weight-bolder"
        >
          {{ toBalance(transaction.amount) }}
        </div>
      </div>
      <div class="border-top transaction-item">
        <b-media no-body>
          <b-media-body>
            <h6 class="transaction-title">
              Total Outstanding
            </h6>
            <!-- <small>{{ transaction.types }}</small> -->
          </b-media-body>
        </b-media>
        <div
          class="font-weight-bolder"
        >
          {{ toBalance(totalOutstanding) }}
        </div>

      </div>
    </b-card-body>

    <Spinner :show="isLoadingLoanPortfolioRiskSummary" />
  </b-card>
</template>

<script>
import {
  BCard, BCardHeader, BCardTitle, BCardBody, BMediaBody, BMedia,
} from 'bootstrap-vue'
import { onMounted, ref } from '@vue/composition-api'
import { useActions } from 'vuex-composition-helpers'
import Spinner from '@/views/components/spinner/Spinner.vue'
import useToastAlert from '../../../composable/useToast'
import { toBalance } from '../../../helpers/formatAmount'

export default {
  components: {
    BCard,
    BCardHeader,
    BCardTitle,
    BCardBody,
    BMediaBody,
    BMedia,
    Spinner,
  },
  setup() {
    const {
      getLoanPortfolioSummary,
    } = useActions({
      getLoanPortfolioSummary: 'dashboard/getLoanPortfolioSummary',
    })
    const { toastAlert } = useToastAlert()
    const isLoadingLoanPortfolioRiskSummary = ref(false)
    const loanPortfolioSummary = ref([])
    const totalOutstanding = ref(0)

    const fetchPortfolioRiskSummary = async () => {
      try {
        isLoadingLoanPortfolioRiskSummary.value = true
        const response = await getLoanPortfolioSummary()

        const { status, data } = response

        if (status === 200 && data) {
          loanPortfolioSummary.value = data.summary
          totalOutstanding.value = data.totalOutstanding
          isLoadingLoanPortfolioRiskSummary.value = false
        }
      } catch (err) {
        toastAlert(err)
      } finally {
        isLoadingLoanPortfolioRiskSummary.value = false
      }
    }

    onMounted(async () => {
      await fetchPortfolioRiskSummary()
      // await getBranches()
    })

    return {
      toBalance,
      loanPortfolioSummary,
      totalOutstanding,
      isLoadingLoanPortfolioRiskSummary,
      fetchPortfolioRiskSummary,
    }
  },
}
</script>
